<template>
    <x-data-table
        class="no-row-hover dashed-rows cell-vertical-align-top cell-padding-vertical"
        :headers="headers"
        :items="formattedData"
        hide-actions
    >
        <template v-slot:items="{ item: offer }">
            <td class="text-xs-left">
                {{ offer.line_size_amount | currency(submission.currency.code) }}
                <br>{{ offer.line_size_percent | percent }}
            </td>
            <template v-if="offer.type === 'retained_percent' && offer.status === 'offered'">
                <td>
                    N/A
                </td>
                <td>
                    N/A
                </td>
                <td>
                    N/A
                </td>
            </template>
            <template v-else>
                <td v-if="['rate', 'percentage_of_net_margin', 'percentage_of_gross_margin', 'retained_percent'].includes(offer.type)"
                    class="text-xs-right">
                    <div v-if="offer.price">
                        {{ offer.price }} BPS
                        <template v-if="offer.percentage_of_margin"><br>({{ offer.percentage_of_margin | percent }} of
                            {{ typeOfMargin(offer) }}  margin)
                        </template>
                    </div>
                    <div v-else-if="offer.percentage_of_margin && offer.minimum_price">
                        Minimum price: {{ offer.minimum_price }} BPS
                        <br>({{ offer.percentage_of_margin | percent }} of {{ typeOfMargin(offer) }} margin)
                    </div>
                </td>
                <td v-else-if="offer.type === 'flat_fee'" class="text-xs-right">
                    {{ offer.flat_fee | currency(submission.currency.code) }}
                </td>

                <td class="text-xs-right">
                    {{ offer.waiting_period }} days
                </td>
                <td class="status-cell text-xs-right">
                    <status-chip :status="offer.status" small/>
                </td>
            </template>
            <td class="text-xs-right">
                <x-btn
                    :disabled="!editable"
                    color="tertiary"
                    class="square-icon extra-small"
                    @click="editOffer()"
                >
                    <i class="material-icons">edit</i>
                </x-btn>
            </td>
        </template>
    </x-data-table>
</template>

<script>
    import StatusChip from '~/components/Shared/UIComponents/StatusChip.vue';
    import premium from '~/mixins/premium';

    export default {
        name: 'OffersTable',
        props: {
          offers: {
            type: Array,
            required: true
          },
          submission: {
            type: Object,
            required: true
          },
          editable: {
            type: Boolean,
            default: false
          }
        },
        components: {
            StatusChip
        },
        data () {
            return {
                headers: [
                    {
                        text: 'Line size',
                        value: 'line_size_amount',
                        align: 'left'
                    },
                    {
                        text: 'Premium rate',
                        value: 'price',
                        align: 'right'
                    },
                    {
                        text: 'Waiting period',
                        value: 'waiting_period',
                        align: 'right'
                    },
                    {
                        text: 'Status',
                        value: 'status',
                        align: 'right'
                    }
                ]
            }
        },
        computed: {
            formattedData() {
                return this.offers.map(offer => ({
                    ...offer,
                    estimatedPremium: this.estimatePremium(offer)
                }));
            }
        },
        methods: {
            calculateRate (offer) {
                return premium.calculate(
                    this.submission.limit_of_liability,
                    offer.price,
                    this.submission.total_risk_period,
                    (offer.line_size_amount / this.submission.limit_of_liability) * 100
                );
            },
            editOffer () {
              this.$emit('edit')
            },
            estimatePremium(offer) {
                if (offer.type === 'rate') { return this.calculateRate(offer); }
                if (offer.type === 'flat_fee') { return offer.flat_fee; }
                if (offer.type === 'percentage_of_net_margin' && this.submission.net_margin) { return this.calculatePercentageOfMargin(offer, this.submission.net_margin); }
                if (offer.type === 'percentage_of_gross_margin' && this.submission.gross_margin) { return this.calculatePercentageOfMargin(offer, this.submission.gross_margin); }
                return '?';
            },
            calculatePercentageOfMargin (offer, margin) {
                const percentageOfMarginPrice = Math.max(Math.ceil((offer.percentage_of_margin / 100) * margin), offer.minimum_price);
                return premium.calculate(
                    this.submission.limit_of_liability,
                    percentageOfMarginPrice,
                    this.submission.total_risk_period,
                    (offer.line_size_amount / this.submission.limit_of_liability) * 100
                );
            },
            typeOfMargin(offer) {
                if (offer.type === 'percentage_of_net_margin') {
                    return 'net';
                } else if (offer.type === 'percentage_of_gross_margin') {
                    return 'gross';
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .x-table.x-datatable tbody tr td.status-cell {
        vertical-align: middle;
    }
</style>
